import { Copy } from "lucide-react";
import { useEffect, useState } from "react";

import { copyToClipboard } from "@/lib/utils";

import { Button } from "./ui/button";

type CopyButtonProps = {
  children: React.ReactNode;
  toCopy: string;
};

export function CopyButton(props: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      const timeout = setTimeout(() => {
        setCopied(false);
      }, 1500);
      return () => clearTimeout(timeout);
    }
  }, [copied]);

  return (
    <Button
      type="button"
      variant="link"
      onClick={() => {
        copyToClipboard(props.toCopy);
        setCopied(true);
      }}
      className="h-auto p-0"
    >
      <Copy className="mr-1 h-4 w-4" />
      {copied ? "Copied!" : props.children}
    </Button>
  );
}
